module.exports = __webpack_public_path__ + "img/page-right.96f07609.svg";